// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rr_a bic_a bic_r bic_sb bic_ry bic_rz","GroupsGrid__row__item":"rr_b bic_be bic_rz"};